import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";
import {
  ExternalPatientServicePlanId,
  PatientId,
  PatientServicePlanId,
} from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => ({
  list: (patientId: PatientId) =>
    queryOptions({
      queryKey: ["patient", patientId, "servicePlans"],
      queryFn: () => api.get("./patients/:patientId/service_plans", { path: { patientId } }),
    }),

  byId: (servicePlanId: PatientServicePlanId) =>
    queryOptions({
      queryKey: ["servicePlan", servicePlanId],
      queryFn: () =>
        api.get("./service_plans/:patientServicePlanId", {
          path: { patientServicePlanId: servicePlanId },
        }),
    }),

  // The plan of care items a task may be mapped to — the same set the extractor
  // was given, so every AI mapping is selectable here.
  planOfCareItems: (patientId: PatientId) =>
    queryOptions({
      queryKey: ["patient", patientId, "servicePlanPlanOfCareItems"],
      queryFn: () => api.get("./patients/:patientId/plan_of_care_items", { path: { patientId } }),
      select: ({ items }) => items,
    }),

  // The imports tab's drawer: everything the pipeline recorded about one
  // submission, which the list connection deliberately reduces to counts.
  coImportDetails: (importId: ExternalPatientServicePlanId) =>
    queryOptions({
      queryKey: ["coServicePlanImport", importId],
      queryFn: () => api.get("./co_service_plan_imports/:importId", { path: { importId } }),
    }),
}));
